import { Api } from 'common/utils/api';
import { useMutation, useQueryClient } from 'react-query';

export interface CreateCompanyRequest {
    name: string;
}

export const useCreateCompany = () => {
    const queryClient = useQueryClient();

    const createCompany = useMutation((data: CreateCompanyRequest) => Api.post({ path: '/partners', body: data }), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partners', 'list'] });
        },
    });
    return {
        createCompany: createCompany.mutateAsync,
    };
};
